import RelatedSiteDetail from '../RelatedSiteDetail';

/** /related/butler-bell — 本文は src/data/related/{ja,en}.ts、描画は RelatedSiteDetail(2026-09-18 作り直し)。 */
export default function RelatedButlerBellPage() {
  return <RelatedSiteDetail slug="butler-bell" />;
}
